import { Link } from "@mui/material";
import { FC, MouseEvent } from "react";

export const PRIVACY_POLICY_PATH = '/politica-de-privacidade';

type PrivacyPolicyLinkProps = {
	label?: string;
};

const PrivacyPolicyLink: FC<PrivacyPolicyLinkProps> = ({ label = 'Política de Privacidade' }) => (
	<Link
		href={PRIVACY_POLICY_PATH}
		target="_blank"
		rel="noopener noreferrer"
		onClick={(event: MouseEvent<HTMLAnchorElement>) => {
			event.preventDefault();
			event.stopPropagation();
			window.open(PRIVACY_POLICY_PATH, '_blank', 'noopener,noreferrer');
		}}
	>
		{label}
	</Link>
);

export default PrivacyPolicyLink;